import { createContext } from "react"

export const UserState = createContext(null)